import { Input, Text } from '@innovationdepartment/proxima-ui';

import { FieldRow, FormSection } from '../CastingProfile.styles';

type AgeSectionProps = {
  ageMin: number | null;
  ageMax: number | null;
  onChangeMin: (value: number | null) => void;
  onChangeMax: (value: number | null) => void;
  errorMin?: string;
  errorMax?: string;
};

// Digit-only input; empty maps to null
const parseAge = (raw: string): number | null => {
  const trimmed = raw.trim();
  if (trimmed === '') return null;
  if (!/^\d+$/.test(trimmed)) return null;
  return Number(trimmed);
};

const AgeSection = ({
  ageMin,
  ageMax,
  onChangeMin,
  onChangeMax,
  errorMin,
  errorMax
}: AgeSectionProps) => (
  <FormSection>
    <Text variant="h5">Age</Text>
    <FieldRow>
      <Input
        label="min"
        value={ageMin?.toString() ?? ''}
        onChange={value => onChangeMin(parseAge(value))}
        error={Boolean(errorMin)}
        helperText={errorMin}
        size="small"
      />
      <Input
        label="max"
        value={ageMax?.toString() ?? ''}
        onChange={value => onChangeMax(parseAge(value))}
        error={Boolean(errorMax)}
        helperText={errorMax}
        size="small"
      />
    </FieldRow>
  </FormSection>
);

export default AgeSection;
